import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ocm-devices",
  templateUrl: "./devices.component.html",
  styleUrls: ["./devices.component.scss"],
})
export class DevicesComponent implements OnInit {
  constructor() {}

  public ngOnInit(): void {}
}
